import { createFileRoute } from "@tanstack/react-router";

import BudgetPage from "@/features/budget/components/BudgetPage";

export const Route = createFileRoute("/_authenticated/budget")({
  component: BudgetPage,
});
